import defaultVideo from "@/assets/F_P_video.mp4";
import otonoAsset from "@/assets/F_P_video_otono_roble.mp4.asset.json";
import navidadAsset from "@/assets/F_P_video_navidad_arbol.mp4.asset.json";
import fiscalAsset from "@/assets/F_P_video_calendario_fiscal_v6.mp4.asset.json";

export type IntroKey = "estandar" | "otono" | "navidad" | "fiscal";

export interface IntroTheme {
  key: IntroKey;
  label: string;
  video: string;
  /** Fondo de la pantalla, igualado al fondo del vídeo. */
  background: string;
  /** true = textos y formulario en modo oscuro. */
  dark: boolean;
  /** true = el vídeo cubre toda la pantalla como fondo. */
  fullscreen?: boolean;
}

export const INTRO_THEMES: Record<IntroKey, IntroTheme> = {
  estandar: { key: "estandar", label: "Estándar", video: defaultVideo, background: "#ffffff", dark: false },
  otono: { key: "otono", label: "Otoño", video: otonoAsset.url, background: "#ffffff", dark: false },
  fiscal: { key: "fiscal", label: "Calendario fiscal", video: fiscalAsset.url, background: "#ffffff", dark: false },
  navidad: {
    key: "navidad",
    label: "Navidad",
    video: navidadAsset.url,
    background: "#010C19",
    dark: true,
    fullscreen: true,
  },
};

/** DEMO: solo se activa con ?intro=otono | ?intro=navidad en la dirección. */
export function getDemoIntroKey(): IntroKey | null {
  if (typeof window === "undefined") return null;
  const v = new URLSearchParams(window.location.search).get("intro");
  return v && v in INTRO_THEMES ? (v as IntroKey) : null;
}

/**
 * Activación automática por calendario (año tras año, no depende del año):
 * Navidad cubre del 7 al 27 de diciembre, ambos inclusive. El resto del año,
 * la intro estándar corporativa.
 */
export function getScheduledIntroKey(): IntroKey {
  if (typeof window === "undefined") return "estandar";
  const now = new Date();
  // Calendario fiscal: puntual, solo hasta el 20 de octubre de 2026 (inclusive).
  if (now < new Date(2026, 9, 21)) {
    return "fiscal";
  }
  if (now.getMonth() === 11 && now.getDate() >= 7 && now.getDate() <= 27) {
    return "navidad";
  }
  return "estandar";
}

export function getIntroTheme(): IntroTheme {
  // El parámetro de demo (?intro=...) tiene prioridad sobre el calendario,
  // para poder probar cualquier tema fuera de sus fechas.
  return INTRO_THEMES[getDemoIntroKey() ?? getScheduledIntroKey()];
}
